import { render, staticRenderFns } from "./ExplodePanel.vue?vue&type=template&id=2a889c27&scoped=true"
import script from "./ExplodePanel.vue?vue&type=script&lang=js"
export * from "./ExplodePanel.vue?vue&type=script&lang=js"
import style0 from "./ExplodePanel.vue?vue&type=style&index=0&id=2a889c27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a889c27",
  null
  
)

export default component.exports